// extracted by mini-css-extract-plugin
export var productImage = "_ox-1";
export var viewLink = "_ox-2";
export var wishlistItem = "_ox-0";